var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-login-v2',{attrs:{"responseMessage":_vm.responseLogin},on:{"onLogin":_vm.onLogin}})}
var staticRenderFns = []

export { render, staticRenderFns }